import React from 'react';
import Header from '../../../components/custom/Header';

const AbtHeader = props => <Header {...props} />;

AbtHeader.propTypes = {
  ...Header.propTypes,
};
export default AbtHeader;
